import {
  AnomalyApi,
} from '@api/twin/AnomalyApi';
import { TwinType } from '@api/twin/TwinApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { usePluginTranslation } from '@translation';
import { anomalyQueryKeys } from '../query-keys';

export const useImportBcfAnomaly = (projectId: number) => {
  const { t } = usePluginTranslation();
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;
  const queryClient = useQueryClient();

  const { mutateAsync: importBcfAnomaly } = useMutation({
    mutationFn: async ({
      files,
      twinProjectType,
    }: {
      files: Array<File>;
      twinProjectType: TwinType;
    }) => await AnomalyApi(client).importBcfAnomaly(projectId, files, twinProjectType),
    onMutate: async () => {
      return viewer.notificationCenter.pushNotification({
        type: t('anomaly_plugin.notification_type_text'),
        status: 'pending',
        message: t('anomaly_plugin.info_widget.upload.pending_text'),
        title: t('anomaly_plugin.info_widget.upload.notification_title'),
        displayed: true,
      });
    },
    onSuccess: async (_data, _variables, notificationId) => {
      await queryClient.invalidateQueries({
        queryKey: anomalyQueryKeys.default,
      });
      viewer.notificationCenter.pushNotification({
        type: t('anomaly_plugin.notification_type_text'),
        status: 'success',
        message: t('anomaly_plugin.info_widget.upload.success_text'),
        title: t('anomaly_plugin.info_widget.upload.notification_title'),
        displayed: true,
      }, notificationId);
    },
    onError: (_error, _variables, notificationId) => {
      viewer.notificationCenter.pushNotification({
        type: t('anomaly_plugin.notification_type_text'),
        status: 'error',
        message: t('anomaly_plugin.info_widget.upload.error_text'),
        title: t('anomaly_plugin.info_widget.upload.notification_title'),
        displayed: true,
      }, notificationId);
    },
  });

  return {
    importBcfAnomaly,
  };
};
